import type { LucideIcon } from '@/lib/icons'

interface IconProps {
  /** The icon component to render (from `@/lib/icons`). */
  icon: LucideIcon
  className?: string
}

/**
 * Renders a decorative inline-SVG icon. Always `aria-hidden` — icons in this app
 * are paired with visible text, never used as the sole label.
 */
export function Icon({ icon: Glyph, className }: IconProps) {
  return <Glyph className={className} aria-hidden="true" />
}
